exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".theme-color-config-theme-color-config-container-3FHCd{width:200px;height:376px}.theme-color-config-theme-color-item-2GHAy{width:100%;height:24px;margin-bottom:8px;display:flex;justify-content:space-between}.theme-color-config-theme-color-item-label-3w2ts{color:rgba(0,0,0,.88);font-family:PingFang SC;font-size:12px;font-style:normal;font-weight:400;line-height:24px}", ""]);

// Exports
exports.locals = {
	"theme-color-config-container": "theme-color-config-theme-color-config-container-3FHCd",
	"theme-color-item": "theme-color-config-theme-color-item-2GHAy",
	"theme-color-item-label": "theme-color-config-theme-color-item-label-3w2ts"
};